// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".imageConatiner[data-v-7ffe65df]{\n  width: 181px;\n  max-width: 181px;\n  height: 136px;\n  max-height: 136px;\n}\n", ""]);
// Exports
module.exports = exports;
